import types from "../actions/actionTypes";
import initialState from "./initialState";


const milestoneTemplatesReducer = (state = initialState.milestoneTemplatesList, action) => {

     const merge = (current, updates) => {       
        let result = current.map(milestoneTemplate => {
            const updateOrNothing = updates.find(pi => pi.id === milestoneTemplate.id);
            if (updateOrNothing !== undefined) {
                return updateOrNothing;
            }
            return milestoneTemplate;
         });   
        const existingIds = result.map(milestoneTemplate => milestoneTemplate.id);
        const newMilestoneTemplates = updates.filter(milestoneTemplate => !existingIds.includes(milestoneTemplate.id));
        return [...result, ...newMilestoneTemplates];   
    }

      const deleteMilestoneTemplate = (current, id) => {
        return current.filter(milestoneTemplate => milestoneTemplate.id !== id);
    } 

    switch (action.type) {
        case types.LOAD_MILESTONETEMPLATES_SUCCESS:
            return action.milestoneTemplatesList;
        case types.LOAD_MILESTONETEMPLATES_UPDATE_SUCCESS:
            return merge(state, action.milestoneTemplatesList);
         case types.DELETED_MILESTONETEMPLATE:    
            return deleteMilestoneTemplate(state, action.id);
        case types.DELETED_MILESTONETEMPLATE_INCOMING:
            return deleteMilestoneTemplate(state, action.payload); 
        default:
            return state;
    }
}


export default milestoneTemplatesReducer;